//
//
//
//
//
//
//
//
//

import Item from "./Item.vue";
export default {
  name: "BlueTags",
  components: { Item },
  computed: {
    tags() {
      const recurse = (filters) => {
        const tags = []
        filters.forEach((f) => {
          if (f.selected) {
            tags.push(f);
          }
          if (f.filters) {
            let _tags = recurse(f.filters);
            if (_tags.length) {
              tags.push(..._tags);
            }
          }
        });
        return tags;
      }
      return this.$store.getters.results.filters.reduce((_tags, g) => {
        const tags = recurse(g.filters);
        _tags.push(...tags);
        return _tags;
      }, []);
    },
  },
  methods: {
    clearAllTags() {
      this.$store.dispatch("removeAllTags");
    },
    removeTag(tag) {
      this.$store.dispatch("removeTagItem", tag);
    },
  },
};
